import React, {ReactNode} from 'react';
import Page from '@episerver/spa-core/Page';
import SelfCarePageData from '../../../Models/Content/SelfCarePageData';
import SelfCare from './SelfCare';

export default class SelfCarePage extends Page<SelfCarePageData> {
  public render(): null | ReactNode {
    return <SelfCare context={this.getContext()} iContent={this.props.data} />;
  }
}
